import { MenuContent, MOBILE_OPEN_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { IPrimitiveProps } from "../../section/Primitive"
import MenuMobileHamburgerDrawer from "./MenuMobileHamburgerDrawer"
import MenuMobileHamburgerPopover from "./MenuMobileHamburgerPopover"
import MenuMobileDefault from "./MenuMobileDefault"

const MenuMobile = (props: IPrimitiveProps): JSX.Element => {
    const primitive: MenuContent = ( props.primitive || {} ) as MenuContent
    switch(primitive.mobileOpenType) {
        case MOBILE_OPEN_TYPE.HAMBURGER_DRAWER:
            return <MenuMobileHamburgerDrawer {...props}/>
        case MOBILE_OPEN_TYPE.HAMBURGER_POPOVER:
            return <MenuMobileHamburgerPopover {...props}/>
        case MOBILE_OPEN_TYPE.NONE:
        default:
            return <MenuMobileDefault {...props}/>
    }
}

export default MenuMobile